import PaginationFooter from "src/components/Shared/PaginationFooter";
import React, { useCallback, useEffect, useState } from "react";
import TRHeader from "src/components/Shared/Table/TRHeader";
import Table from "src/components/Shared/Table/Table";
import { connect } from "react-redux";
import { apiRequest } from "src/async/apiUtils";
import ClientUserEntry from "./ClientUserEntry";

const ClientUserList = ({ client }) => {
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);

  const [admins, setAdmins] = useState([]);
  const [meta, setMeta] = useState({});
  const [adminsLoaded, setAdminsLoaded] = useState(false);

  const getAdminsList = useCallback(async () => {
    try {
      setAdminsLoaded(false);

      const res = await apiRequest("get", `/clients/:client_id/users`, {
        queries: { limit, offset },
        params: { client_id: client?._id },
      });

      if (res.data.status === 200) {
        setAdmins(res.data.data || []);
        setMeta(res?.data?.meta || {});
      } else {
        setAdminsLoaded(true);
        setAdmins([]);
      }
    } catch (error) {
    } finally {
      setAdminsLoaded(true);
    }
  }, [limit, offset, client?._id]);

  useEffect(() => {
    getAdminsList();
  }, [getAdminsList]);

  const handlePaginationChange = ({ limit, offset }) => {
    setLimit(limit);
    setOffset(offset);
  };

  return (
    <>
      <Table
        tableHeader={
          <TRHeader>
            <th
              scope="col"
              className="hidden min-w-[250px] rounded-tl-lg py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:table-cell sm:pl-6">
              Name
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
              Last Active
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 pr-8 text-end text-sm font-semibold text-gray-900">
              Manage Role
            </th>
          </TRHeader>
        }
        colSpan="5"
        loaded={adminsLoaded}
        dataExists={admins?.length > 0}>
        {admins?.map((item, index) => (
          <ClientUserEntry
            key={index}
            user={item}
            client={client}
            refreshList={getAdminsList}
          />
        ))}
      </Table>
      <PaginationFooter
        itemName="Admin record"
        limit={limit}
        offset={offset}
        count={meta?.count}
        onChange={handlePaginationChange}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    site: state.site,
  };
};

export default connect(mapStateToProps, {})(ClientUserList);
